// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"8cd24b45","453":"4259f264"}[chunkId] + ".chunk.js";
};